import {useQuery, queryOptions} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {
  CopilotChatOrg,
  CopilotChatPayload,
  CopilotChatReference,
} from '@github-ui/copilot-chat/utils/copilot-chat-types'

export interface ChatPayload extends CopilotChatPayload {
  findFileWorkerPath: string
  refs?: CopilotChatReference[]
  ssoOrganizations?: CopilotChatOrg[]
}

export const copilotChatPayloadQueryOptions = queryOptions({
  queryKey: ['copilot-chat-payload'],
  queryFn: async (): Promise<ChatPayload> => {
    const resp = await verifiedFetchJSON('/github-copilot/chat')
    if (!resp.ok) {
      throw new Error(`Failed to fetch chat provider: ${resp.statusText}`)
    }
    return (await resp.json()) as ChatPayload
  },
})

export function useCopilotChatPayloadQuery() {
  const {data = null} = useQuery(copilotChatPayloadQueryOptions)
  return data
}
